<template>
    <b-modal
      size="md"
      :hideFooter="true"
      :hideHeader="true"
      id="confirmReleaseStudentModal"
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt">
          <b-row class="text-center">
            <h6 class="confirm-modal-text">
              Вы действительно хотите выпустить данного студента?
            </h6>
          </b-row>
          <b-row class="text-center ">
            <h5 class="releaseStudentName">
              {{ releaseStudentInfo }}
            </h5>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6">
              <b-button @click="releaseStudent" class="confirm-modal-btn" variant="primary">
                Подтвердить
              </b-button>
            </b-col>
            <b-col class="col-12 col-md-6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

export default {
  name: 'ConfirmReleaseStudentModal',
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    },
    surname: {
      type: String,
      default() {
        return ''
      }
    },
    midname: {
      type: String,
      default() {
        return ''
      }
    },
    id: {
      type: Number,
      default() {
        return null
      }
    }
  },
  computed: {
    releaseStudentInfo() {
      return `${this.releaseStudentSurname} ${this.releaseStudentName} ${this.releaseStudentMidname}`
    },
    releaseStudentName: {
      get() {
        return this.name
      },
      set() {
        this.name = this.$props.name
      }
    },
    releaseStudentSurname: {
      get() {
        return this.surname
      },
      set() {
        this.surname = this.$props.surname
      }
    },
    releaseStudentMidname: {
      get() {
        return this.midname
      },
      set() {
        this.midname = this.$props.midname
      }
    },
    releaseStudentId: {
      get() {
        return this.id
      },
      set() {
        this.id = this.$props.id
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('confirmReleaseStudentModal')
    },
    releaseStudent() {
      this.$emit('studentReleased')
      this.closeModal()
    }
  }
}
</script>

<style scoped lang="scss">

  .confirm-modal-btn {
    width: 100% !important;
  }

  .confirm-modal-text {
    display: inline-block;
    margin: 0 auto;
    width: 90%;
    margin-bottom: 20px;
  }

  .releaseStudentName {
    width: 100%;
    margin-bottom: 20px;
  }

</style>
